import {createElement, PropTypes} from 'rlink-react';
import {mergeStaticOptions, inArray} from 'rlink-utils/object';

import InputBase from './InputBase';

export default class CheckboxGroupInput extends InputBase {
  constructor (props, context) {
    super(props, context);
    this.selected = {};
  }

  get inputType () {
    return 'checkbox';
  }

  get choices () {
    return this.fromPropsOrContext('choices');
  }

  componentWillMount () {
    // @TODO and also componentWilLReceiveProps
    // update this.selected based on this.value

    if (Array.isArray(this.value)) {
      for (let idx in this.choices) {
        if (inArray(this.choices[idx].value, this.value)) {
          this.selected[idx] = true;
        }
      }
    }
  }

  hasValue (value) {
    return value && value.length > 0;
  }

  normalizeValue (value) {
    if (Array.isArray(value)) {
      return value;
    } else {
      return [value];
    }
  }

  handleChange (ev) {
    this.selected[ev.target.value] = ev.target.checked;

    let value = [];
    for (let selectedIdx in this.selected) {
      if (this.selected[selectedIdx]) {
        value.push(this.choices[Number(selectedIdx)].value);
      }
    }

    this.fireCommitValue(ev, value);
    return super.handleChange({
      event: ev,
      value,
    });
  }

  renderLabel (label) {
    if (typeof label === 'object'
        && label !== null
        && '__html' in label) {
      return (<span
        className="labelText"
        dangerouslySetInnerHTML={label} />);
    } else {
      return (<span className="labelText">
        {label}
      </span>);
    }
  }

  renderInput () {
    return this.choices.map((option, idx) =>
      <label key={idx}>
        <input type={this.inputType}
          disabled={this.disabled}
          name={this.name}
          onFocus={ev => this.handleFocus(ev)}
          onBlur={ev => this.handleBlur(ev)}
          onChange={ev => this.handleChange(ev)}
          checked={(this.value || []).some(value => value === option.value)}
          value={idx} />
        {this.renderLabel(option.label)}
      </label>);

  }

  render () {
    return (<div className={`control ${this.className}`}>
      {this.renderInput()}
      {this.renderHelp()}
      {this.renderError()}
    </div>);
  }
}


mergeStaticOptions(CheckboxGroupInput, {
  propTypes: {
    choices: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.shape({
          __html: PropTypes.string,
        }),
      ]),
      value: PropTypes.any,
    })),
  },
  defaultProps: {
    choices: [],
  },
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/CheckboxGroupInput.jsx